import { Filter } from "../OrderListContext";

export const deepCopyFilters = (filters: Filter[]) : Filter[]=> {
  return filters.map(filter => ({
    ...filter,
    items: filter.items.map((el) => ({...el, chosen: undefined}))
  }));
}